/*
 * Navigation desktop 2026 — snippets/nav-desktop-2026.liquid
 * Pilote l'ouverture des panneaux (classe .is-open) avec des délais
 * d'intention, pour qu'aller de l'entrée vers son panneau ne le referme pas :
 *  - sortie de la nav : fermeture après CLOSE_DELAY (traverser une zone vide
 *    de la barre, en diagonale vers les visuels, ne ferme rien) ;
 *  - passage sur une autre entrée alors qu'un panneau est ouvert : bascule
 *    seulement si la souris s'y arrête SWITCH_DELAY (frôler SCIENCE en
 *    allant vers le panneau SHOP ne le remplace pas) ;
 *  - Échap : referme et rend le focus à l'entrée ;
 *  - tactile : 1er tap ouvre, 2e tap suit le lien ; tap ailleurs ferme.
 * Clavier : ouverture en CSS via :focus-visible.
 */
(function () {
  var nav = document.querySelector('[data-nav26]');
  if (!nav) return;

  var OPEN_DELAY = 60;
  var SWITCH_DELAY = 180;
  var CLOSE_DELAY = 350;

  var items = Array.prototype.slice.call(nav.querySelectorAll('.nav26__item'));
  var current = null;
  var openTimer = null;
  var closeTimer = null;

  nav.classList.add('nav26--js');

  function hasPanel(item) {
    return item.classList.contains('nav26__item--has-panel');
  }

  var switchTimer = null;

  function setOpen(item) {
    clearTimeout(openTimer);
    clearTimeout(closeTimer);
    var next = item && hasPanel(item) ? item : null;
    // Panneau → autre panneau : pas de repli/redéploiement (cf. CSS).
    if (current && next && next !== current) {
      nav.classList.add('nav26--switching');
      clearTimeout(switchTimer);
      switchTimer = setTimeout(function () {
        nav.classList.remove('nav26--switching');
      }, 50);
    }
    current = next;
    items.forEach(function (it) {
      var open = it === current;
      it.classList.toggle('is-open', open);
      if (hasPanel(it)) it.querySelector('.nav26__top').setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  items.forEach(function (item) {
    item.addEventListener('mouseenter', function () {
      clearTimeout(closeTimer);
      clearTimeout(openTimer);
      if (item === current) return;
      if (!current && !hasPanel(item)) return;
      nav.classList.remove('is-dismissed');
      openTimer = setTimeout(function () {
        setOpen(item);
      }, current ? SWITCH_DELAY : OPEN_DELAY);
    });

    item.addEventListener('mouseleave', function () {
      // Quitter une entrée sans s'y être arrêté annule la bascule prévue.
      clearTimeout(openTimer);
    });

    var top = item.querySelector('.nav26__top');
    top.addEventListener('click', function (event) {
      if (!hasPanel(item) || !nav.dataset.touch) return;
      if (item !== current) {
        event.preventDefault();
        nav.classList.remove('is-dismissed');
        setOpen(item);
      }
    });
  });

  nav.addEventListener('mouseenter', function () {
    clearTimeout(closeTimer);
  });

  nav.addEventListener('mouseleave', function () {
    clearTimeout(openTimer);
    clearTimeout(closeTimer);
    closeTimer = setTimeout(function () {
      setOpen(null);
      nav.classList.remove('is-dismissed');
    }, CLOSE_DELAY);
  });

  // pointerType n'est pas fiable sur l'événement click partout (Safari) :
  // on mémorise le type du dernier pointerdown.
  nav.addEventListener('pointerdown', function (event) {
    if (event.pointerType === 'touch') nav.dataset.touch = '1';
    else delete nav.dataset.touch;
  });

  document.addEventListener('pointerdown', function (event) {
    if (current && !nav.contains(event.target)) setOpen(null);
  });

  nav.addEventListener('focusin', function () {
    nav.classList.remove('is-dismissed');
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var open = current || items.filter(function (it) {
      return it.contains(document.activeElement);
    })[0];
    if (!open) return;
    setOpen(null);
    // focus() déclenche focusin (qui lève is-dismissed) : on rend le focus d'abord.
    if (open.contains(document.activeElement)) open.querySelector('.nav26__top').focus();
    nav.classList.add('is-dismissed');
  });
})();
